import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { ArticleTheme } from './enum';

export const QUERY_KEY = ['LATEST_ARTICLES'] as const;
export const QUERY = gql(`
  query getHumanArticleList($offset: Int, $limit: Int, $theme: String) {
    humanArticleList(
      offset: $offset
      limit: $limit
      tags: { theme: [$theme] }
    ) {
      total
      articles {
        id
        title
        created
        excerpt
        slug
        canonicalURL
        coverURL
        author {
          name
          photoURL
          slug
        }
      }
    }
  }
`);

export type QueryRequest = {
  readonly offset: number;
  readonly limit: number;
  readonly theme: ArticleTheme;
};

export async function queryFn({
  queryKey: [_, offset, limit, theme],
}: QueryFunctionContext<[string, number, number, ArticleTheme]>) {
  const { humanArticleList } = await gqlClient.request(QUERY, {
    offset,
    limit,
    theme,
  });
  return {
    total: humanArticleList.total,
    articles: humanArticleList.articles,
  };
}
